module["exports"] = [
  "#{prefix} #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/company/name.js
// module id = 2186
// module chunks = 0